import axios from "axios";

const defaultCalendarSetting = {
    view: 'month',
};

const initialState = {
    calendarEvents: [],
    calendarSetting: {...defaultCalendarSetting},
    calendarLabels: [],
};

const state = Object.assign({}, initialState);

const getters = {
    calendarEvents: state => state.calendarEvents,
    calendarSetting: state => state.calendarSetting,
    calendarLabels: state => state.calendarLabels,
};

const mutations = {
    setCalendarEvents: (state, calendarEvents) => (state.calendarEvents = calendarEvents),
    setCalendarSetting: (state, calendarSetting) => (state.calendarSetting = calendarSetting),
    setCalendarLabels: (state, calendarLabels) => (state.calendarLabels = calendarLabels),
};

const actions = {
    async fetchCalendarEvents({commit}, params) {
        const {data} = await axios.get('/v2/calendar-events');

        commit('setCalendarEvents', data.data);
    },
    async fetchCalendarSetting({commit}, params) {
        const {data} = await axios.get('/v2/calendar-settings');
        const calendarSetting = data.data.calendar_setting || defaultCalendarSetting;

        commit('setCalendarSetting', calendarSetting);
    },
    async fetchCalendarLabels({commit}, params) {
        const {data} = await axios.get('/v2/labels');

        commit('setCalendarLabels', data.data);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
